const fakeRepo = {
  push() {
    return null;
  },
  length: [],
};

export default class {
  private readonly repoObject: any;

  constructor(repoObject = fakeRepo) {
    this.repoObject = repoObject;
  }

  send(data: unknown): void {
    this.repoObject.push(data);
  }

  getPlatformName() {
    return getPageNode(this.repoObject, (repoObject) => {
      return repoObject.page.platformName;
    });
  }

  getPageType() {
    return getPageNode(this.repoObject, (repoObject) => {
      return repoObject.page.type;
    });
  }

  getCategory() {
    return getPageNode(this.repoObject, (repoObject) => {
      return repoObject.page.category;
    });
  }

  getPageSection() {
    return getPageNode(this.repoObject, (repoObject) => {
      return repoObject.page.section;
    });
  }

  getBrand() {
    return getPageNode(this.repoObject, (repoObject) => {
      return repoObject.page.brand;
    });
  }

  getLocale() {
    return getPageNode(this.repoObject, (repoObject) => {
      return repoObject.page.locale;
    });
  }

  getClientId() {
    for (let i = this.repoObject.length - 1; i >= 0; i -= 1) {
      if (this.repoObject[i].clientId) {
        return this.repoObject[i].clientId;
      }
    }
    return null;
  }

  getAction() {
    return getUserInteractionNode(this.repoObject, (repoObject) => {
      return repoObject.user.interaction.action;
    });
  }

  getLabel() {
    return getUserInteractionNode(this.repoObject, (repoObject) => {
      return repoObject.user.interaction.label;
    });
  }

  getEventCategory() {
    return getUserInteractionNode(this.repoObject, (repoObject) => {
      return repoObject.user.interaction.category;
    });
  }

  wasEventEmitted(eventName) {
    for (let i = this.repoObject.length - 1; i >= 0; i -= 1) {
      if (this.repoObject[i] && this.repoObject[i].event && this.repoObject[i].event === eventName) {
        return true;
      }
    }

    return false;
  }
}

function getPageNode(repoObject, nodeExtractor) {
  for (let i = repoObject.length - 1; i >= 0; i -= 1) {
    if (repoObject[i] && repoObject[i].page && nodeExtractor(repoObject[i])) {
      return nodeExtractor(repoObject[i]);
    }
  }

  return null;
}

function getUserInteractionNode(repoObject, nodeExtractor) {
  for (let i = repoObject.length - 1; i >= 0; i -= 1) {
    if (repoObject[i] && repoObject[i].user && repoObject[i].user.interaction && nodeExtractor(repoObject[i])) {
      return nodeExtractor(repoObject[i]);
    }
  }

  return null;
}
